/*eslint camelcase: ["error", {properties: "never"}]*/
/*global setEnviorment, Stadistic*/
import { DELEGATION_TYPE } from 'food-benefit.module/common/domain/constants';

const ENV = {
  pro: 'HPDBBVAG2PROD',
  pre: 'HPDBBVAG2PRE'
};

const ATOM = {
  loans: '00000160',
  'food-benefit': 'AYAL',
  'vacations-absences': '00000060'
};

const DATA_ORIGIN = 'móvil'; //Web o móvil

export default class MetricsService {

  constructor($log, $window, gProfileService) {
    'ngInject';
    this.log = $log;
    this.window = $window;

    this.gProfileService = gProfileService;

    if (this.getIsMobileApp()) {
      this.env = this.getEnv();
      this.atom = this.getAtom();
      this.device = this.initDeviceInfo();
      try {
        setEnviorment(this.env);
        this.stadistic = new Stadistic();
      } catch (e) {
        this.log.error('error stadistic setEnviorment and/or new Stadistic()', e);
      }
    }
  }

  getIsMobileApp() {
    return !!this.window.isMobileApp;
  }

  getEnv() {
    let env = process.env.isDev ? ENV.pre : ENV.pro;
    this.log.info('stadistic environment', env);
    return env;
  }

  getAtom() {
    const atom = ATOM[process.env.APP] || 'Web Autoservicios';
    this.log.info('stadistic atom', atom);
    return atom;
  }

  initDeviceInfo() {
    if (window.device === undefined) {
      this.window.device = {
        version: 'notADevice'
      };
    }
    this.log.info('stadistic device info', this.window.device);
    return this.window.device;
  }

  init() {
    this.log.info('stadistic init isMobileApp', this.getIsMobileApp());

    if (this.getIsMobileApp()) {
      // Obtain authenticated user google profile data
      this.gProfileService.getSession().then((response) => {
        const gprofile = response;
        this.log.info('init stadistic with gprofile', JSON.stringify(gprofile));

        let data = {};
        data.Idioma = gprofile.locale;
        data.UID = gprofile.employeeId;
        data.CargoFuncional = gprofile.functionalCode;
        data.Empleado = gprofile.sIsEmployee;
        data.Directivo = this.isExecutive(gprofile.globalRange);
        data.App_actual = this.atom;
        data.OrigenDatos = DATA_ORIGIN;
        data.Pais = gprofile.countryCode;
        data.Empresa = gprofile.companyCode;
        data.UONivel1 = gprofile.ous[0].ouCode;
        data.UONivel2 = gprofile.ous[1].ouCode;
        data.UONivel3 = gprofile.ous[2].ouCode;
        data.UONivel4 = gprofile.ous[3].ouCode;
        data.UONivel5 = gprofile.ous[4].ouCode;
        data.UONivel6 = gprofile.ous[5].ouCode;
        data.UONivel7 = gprofile.ous[6].ouCode;
        data.UONivel8 = gprofile.ous[7].ouCode;
        data.UONivel9 = gprofile.ous[8].ouCode;
        data.UONivel10 = gprofile.ous[9].ouCode;
        this.log.info('stadistic data', JSON.stringify(data));

        try {
          this.stadistic.init(data);
          this.log.info('stadistic object', JSON.stringify(this.stadistic));

          this._trackAccessApp();
        } catch (e) {
          this.log.error('error stadistic.init', e);
        }
      }, error => {
        this.log.error('Error al obtener el GProfile: ', JSON.stringify(error));
      });
    }
  }

  isExecutive(globalRange) {
    return (globalRange != null && (globalRange == '6' || globalRange == '7' || globalRange == '0'));
  }

  _trackAccessApp() {
    this.log.info('_trackAccessApp isMobileApp', this.getIsMobileApp());

    const eVars = {
      'eVar73': this.atom,
      'eVar75': this.device.version
    };
    const props = {
      'prop73': this.atom,
      'prop75': this.device.version
    };
    this.log.info('_trackAccessApp', JSON.stringify(eVars), JSON.stringify(props));

    if (this.getIsMobileApp()) {
      try {
        this.log.info('_trackAccessApp stadistic environment', this.env);
        this.log.info('_trackAccessApp stadistic atom', this.atom);
        this.log.info('_trackAccessApp stadistic object', JSON.stringify(this.stadistic));
        this.log.info('_trackAccessApp', JSON.stringify(eVars), JSON.stringify(props));
        this.stadistic.registraSeguimientoGenerico(eVars, props, ['event71', 'event1'], true);
      } catch (e) {
        this.log.error('error stadistic.registraSeguimientoGenerico', e);
      }
    }
  }

  trackLoansSimulation() {
    this.log.info('trackLoansSimulation');
    const SIMULATION = 'Simulación';

    if (this.getIsMobileApp()) {
      const eVars = {
        'eVar70': this.atom,
        'eVar71': SIMULATION,
        'eVar75': this.device.version
      };
      const props = {
        'prop70': this.atom,
        'prop71': SIMULATION,
        'prop75': this.device.version
      };
      this._trackAction(eVars, props);
    }
  }

  trackLoansSignup(params) {
    this.log.info('trackLoansSignup', params);
    const SIGN_UP = 'Contratación';
    const PARAM_LOAN_TYPE = 'loanType';

    if (this.getIsMobileApp()) {
      const eVars = {
        'eVar70': this.atom,
        'eVar71': SIGN_UP,
        'eVar72': params[PARAM_LOAN_TYPE],
        'eVar75': this.device.version
      };
      const props = {
        'prop70': this.atom,
        'prop71': SIGN_UP,
        'prop72': params[PARAM_LOAN_TYPE],
        'prop75': this.device.version
      };
      this._trackAction(eVars, props);
    }
  }

  trackFoodBenefitDelegation(params) {
    this.log.info('trackFoodBenefitDelegation', params);
    const PARAM_DELEGATION_TYPE = 'delegationType';
    const DELEGATION_TYPES = {};
    DELEGATION_TYPES[DELEGATION_TYPE.MANAGER] = 'Delegación manager';
    DELEGATION_TYPES[DELEGATION_TYPE.EMPLOYEE] = 'Delegación empleado';
    const delegationType = DELEGATION_TYPES[params[PARAM_DELEGATION_TYPE]];

    if (this.getIsMobileApp()) {
      const eVars = {
        'eVar70': this.atom,
        'eVar71': delegationType,
        'eVar75': this.device.version
      };
      const props = {
        'prop70': this.atom,
        'prop71': delegationType,
        'prop75': this.device.version
      };
      this._trackAction(eVars, props);
    }
  }

  trackVacationsAbsencesDelegation() {
    this.log.info('trackVacationsAbsencesDelegation');
    const DELEGATION = 'Delegación';

    if (this.getIsMobileApp()) {
      const eVars = {
        'eVar70': this.atom,
        'eVar71': DELEGATION,
        'eVar75': this.device.version
      };
      const props = {
        'prop70': this.atom,
        'prop71': DELEGATION,
        'prop75': this.device.version
      };
      this._trackAction(eVars, props);
    }
  }

  trackVacationsAbsencesCreateAbsenceFromManagerToEmployee() {
    this.log.info('trackVacationsAbsencesCreateAbsenceFromManagerToEmployee');
    const CREATE_ABSENCE = 'Crear ausencia de manager a empleado';

    if (this.getIsMobileApp()) {
      const eVars = {
        'eVar70': this.atom,
        'eVar71': CREATE_ABSENCE,
        'eVar75': this.device.version
      };
      const props = {
        'prop70': this.atom,
        'prop71': CREATE_ABSENCE,
        'prop75': this.device.version
      };
      this._trackAction(eVars, props);
    }
  }

  _trackAction(eVars, props) {
    this.log.info('_trackAction isMobileApp', this.getIsMobileApp());
    this.log.info('_trackAction', JSON.stringify(eVars), JSON.stringify(props));

    if (this.getIsMobileApp()) {
      try {
        this.log.info('_trackAction stadistic environment', this.env);
        this.log.info('_trackAction stadistic atom', this.atom);
        this.log.info('_trackAction stadistic object', JSON.stringify(this.stadistic));
        this.stadistic.registraSeguimientoGenerico(eVars, props, ['event70']);
      } catch (e) {
        this.log.error('error stadistic.registraSeguimientoGenerico', e);
      }
    }
  }

  trackNavigationVacationsAbsencesTeamCalendar() {
    const TEAM_CALENDAR = 'Calendario de Equipo';
    this._trackNavigation(TEAM_CALENDAR);
  }

  _trackNavigation(navigateTo) {
    this.log.info('_trackNavigation isMobileApp', this.getIsMobileApp());

    const eVars = {
      'eVar73': this.atom,
      'eVar74': navigateTo,
      'eVar75': this.device.version
    };
    const props = {
      'prop73': this.atom,
      'prop74': navigateTo,
      'prop75': this.device.version
    };
    this.log.info('_trackNavigation', JSON.stringify(eVars), JSON.stringify(props));

    if (this.getIsMobileApp()) {
      try {
        this.log.info('_trackNavigation stadistic environment', this.env);
        this.log.info('_trackNavigation stadistic atom', this.atom);
        this.log.info('_trackNavigation stadistic object', JSON.stringify(this.stadistic));
        this.stadistic.registraSeguimientoGenerico(eVars, props, ['event72', 'event1'], true);
      } catch (e) {
        this.log.error('error stadistic.registraSeguimientoGenerico', e);
      }
    }
  }

}



// WEBPACK FOOTER //
// ./client/app/mobile/metrics/metrics.service.js